interface EvidenceCalloutProps {
  quote: string;
  source: string;
  href?: string;
}

export function EvidenceCallout({ quote, source, href }: EvidenceCalloutProps) {
  return (
    <aside className="relative overflow-hidden rounded-3xl border border-primary/20 bg-lavender p-8 md:p-10">
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full opacity-40 blur-3xl"
        style={{ background: "radial-gradient(closest-side, var(--primary-glow), transparent)" }}
        aria-hidden="true"
      />
      <p className="relative font-display text-xl leading-snug text-ink md:text-2xl">{quote}</p>

      <p className="relative mt-4 text-sm text-muted-foreground">
        {href ? (
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="text-primary underline-offset-4 hover:underline"
          >
            {source}
          </a>
        ) : (
          source
        )}
      </p>
    </aside>
  );
}
